import { render } from "./KryptonGhostContainer.vue?vue&type=template&id=6a7db0d2&lang=pug"
import script from "./KryptonGhostContainer.vue?vue&type=script&lang=js"
export * from "./KryptonGhostContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__